<template>
    <!-- 登录 by 琦琦 -->
    <div class="login-layout">
        <el-dialog
            custom-class="logDialog"
            :visible.sync="show"
            width="4.4rem"
            :show-close="isShowClose"
            :before-close="notHideDialog"
            :modal-append-to-body="false"
        >
            <!-- 头部 -->
            <img loading="lazy"
                class="close-img cursorPoint"
                v-lazy="require('../../static/image/pn/close.png')"
                @click="closeDialog"
            />

            <div class="log-title">{{$t('loginPage.memberLogin')}}</div>

            <div class="log-container">
                <div class="log-row account-row">
                    <input
                        type="text"
                        class="logInput"
                        :placeholder="$t('loginPage.accountP')"
                        v-model="accountNumber"
                        autofocus
                        @blur="accountBlur"
                    />
                </div>

                <div class="log-row password-row">
                    <input
                        v-show="defaultType"
                        type="password"
                        class="logInput"
                        :placeholder="$t('loginPage.passwordP')"
                        v-model="password"
                        @blur="passwordBlur"
                    />
                    <input
                        v-show="!defaultType"
                        type="text"
                        class="logInput"
                        :placeholder="$t('loginPage.passwordP')"
                        v-model="password"
                        @blur="passwordBlur"
                    />
                    <img loading="lazy"
                        v-lazy="defaultType ? require('../../assets/images/qiqi/notVisible.png') :require('../../assets/images/qiqi/visible.png')"
                        @click="defaultType=!defaultType"
                        class="right-img"
                        alt
                    />
                </div>

                <!-- 改版提示 -->
                <div class="updateTips" v-if="loginJson && loginJson.title">
                    <span class="themeTextColor">{{ loginJson.title }}</span>
                    {{ loginJson.content }}
                </div>

                <!--验证码-->
                <div v-if="type === 0" class="log-row code-row marginStyle">
                    <input
                        type="text"
                        class="logInput"
                        :placeholder="$t('loginPage.verifyCodeP')"
                        v-model="captchaCode"
                        @blur="captchaCode = toCDB(captchaCode)"
                        @keyup.enter="login"
                    />
                    <div
                        class="verifyCodeImg"
                        v-if="verifyCodeImg"
                        @click="captchaData"
                        :style="'background-image:url(' + verifyCodeImg + ')'"
                    ></div>
                    <div class="verifyCodeImg getCode u-flex-all" v-if="!verifyCodeImg">
                        <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" alt />
                        {{ $t("loginPage.regain") }}
                    </div>
                </div>

                <!-- 行为校验  树莓 -->
                <div
                    v-show="type === 2"
                    id="captcha"
                    class="captchaStyle"
                    @click="captchaClick"
                >{{ captchaText }}</div>

                <!--  行为验证 极验 -->
                <div v-show="type === 1" id="captcha1" class="marginStyle"></div>
                 <!--  行为验证 极验4 -->
                <div v-show="type === 3" id="gt43" class="marginStyle"></div>
                <!-- getDefaultStatus接口请求失败 -->
                <div
                    class="marginStyle getCode u-flex-all cursorPoint"
                    v-if="errorCode"
                    @click="getDefaultStatus"
                >
                    <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" />
                    {{ $t("loginPage.regain") }}
                </div>

                <div
                    class="submit-btn u-flex-all log-btn cursorPoint buttonHover1"
                    @click="login"
                >{{ $t("loginPage.login") }}</div>

                <div class="log-bottom">
                    <div
                        class="cursorPoint"
                        @click="showForgetPsw"
                    >{{ $t("loginPage.retrievePassword") }}</div>
                    <div class="cursorPoint" @click="toRegister">
                        {{ $t("loginPage.notAccount") }}
                        <span
                            style="color:#ff3a2b;"
                        >{{ $t("loginPage.fastRegister") }}</span>
                    </div>
                </div>
            </div>
        </el-dialog>

        <forgetPsw ref="forgetPsw"></forgetPsw>
        <validateLogin ref="validateLogin" @login="login" :accountNumber="accountNumber"></validateLogin>
    </div>
</template>

<script>
import MyAes from "../../utils/myAes.js";
import store from "../../store/store";
import forgetPsw from "@/components/forgetPsw/forgetPsw";
import validateLogin from "@/components/validateLogin/validateLogin";
import "../../utils/smcp.min.js";
import gt from "../../utils/gt.js";
import { showLogin } from "./login.js";
import "../../utils/boc"
export default {
    name: "login",
    data() {
        return {
            show: false,
            captchaCode: "",
            captchaKey: "",
            isShowClose: false,
            accountNumber: "",
            defaultType: false,
            password: "",
            verifyCodeImg: "--",
            isClickLogin: true, //只有第一次登录生效，除非登录失败
            window: window,
            dataList: null,
            loginJson: null,
            type: 1, //行为校验2
            captcha: null, //行为校验
            captchaBox: null,
            captchaText: "",
            captchaMask: false,
            errorCode: false,
            validateStatus: -1, //默认Login异常
            defaultType: true //默认密文
        };
    },
    mounted() {
        this.loginSet();
        this.getDefaultStatus();
    },
    methods: {
        closeDialog() {
            this.show = false;
        },
        // 获取   getDefaultStatus
        getDefaultStatus() {
            let _this = this;
            this.$http.get(this.$api.getDefaultStatus, false).then(res => {
                if (res.code == 0) {
                    // type   0：默认验证码  1：极验  2：数美"
                    _this.type = res.data.type;
                    // _this.type = 1;
                    if (_this.type === 0) {
                        //图片验证码
                        //获取验证码图片
                        this.captchaData();
                    } else if (_this.type === 1 || _this.type ===3) {
                        //1：极验
                        _this.reset();
                    } else if (_this.type === 2) {
                        //2：数美"
                        _this.reset();
                    }
                } else {
                    this.errorCode = true;
                    this.type = null;
                    this.moneyModeListReqSuccess = false;
                    this.$message.error(this.$t("loginPage.loadFail"));
                }
            });
        },
        //行为校验↓
        reset() {
            this.check();
            this.getCaptcha();
        },
        check() {
            if(this.type === 3){
                this.captcha && this.captcha.reset()
            } else {
                if (this.captcha) {
                    this.captchaText = "";
                } else {
                    this.captchaText = this.$t("loginPage.loading");
                }
            }
           
        },
        getCaptcha() {
            let lang = "zh";
            if (this.$config.local == "en_US") {
                lang = "en";
            } else if (this.$config.local == "zh_CN") {
                lang = "zh-cn";
            } else if (this.$config.local == "zh_HK") {
                lang = "zh-hk";
            }
            if (this.type == 1) {
                let _this = this;
                this.$http
                    .get(
                        this.$api.geetFirstRegister,
                        "?t=" + window.childCode,
                        false
                    )
                    .then(res => {
                        if (res.code == 0) {
                            window.initGeetest(
                                {
                                    gt: res.data.gt,
                                    challenge: res.data.challenge,
                                    new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                                    offline: res.data.success !== 1, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                                    product: "float", // 产品形式，包括：float，popup
                                    width: "100%",
                                    lang: lang
                                },
                                _this.onCaptcha
                            );
                        } else {
                            this.$message.error(this.$t("loginPage.getError"));
                        }
                    });
            } else if (this.type == 2) {
                // initSMCaptcha(
                //     {
                //         'organization': 'p0Omlm53sVbJpKBtYtCg',
                //         'product': 'popup',
                //         'width': 300,
                //         'https': location.protocol == 'https:'
                //     },
                //     this.onCaptcha
                // );
            } else if(this.type === 3){
                if (!this.captcha) {
                    initBotion({
                    captchaId: this.$config.captchaId,
                    product: 'popup',//float  popup
                    language: lang,
                    nativeButton:{
                        width: '2rem',
                        height: '0.35rem'
                    }
                    }, this.onCaptcha);
                }
            }
        },
        onCaptcha(res) {
            //res是验证实例，可以调用res的示例方法
            var _this = this;
            this.captcha = res;
            if (_this.type == 1) {
                res.appendTo("#captcha1");
                res.onReady(_this.check);
            } else if (this.type == 2) {
                this.captchaText = _this.$t("loginPage.clickBtnToVerify");
                this.captcha.onSuccess(function(data) {
                    if (data.pass) {
                        _this.captcha.rid = data.rid;
                        _this.captchaText = _this.$t("loginPage.verifySuccess");
                        _this.captchaMask = false;
                    } else {
                        _this.captcha.rid = null;
                        _this.captchaText = _this.$t("loginPage.verifyFail");
                    }
                });

                this.captcha.onError(function() {
                    _this.captcha.rid = null;
                    _this.captchaText = _this.$t("loginPage.verifyFail");
                    _this.captchaMask = false;
                });

                this.captcha.onClose(function() {
                    _this.captchaMask = false;
                });
            } else if(this.type === 3){
                  res.appendTo("#gt43");
            }
        },
        captchaClick() {
            if (this.type == 2) {
                var result = this.captcha.getResult();
                var pass = result.pass;
                if (!pass) {
                    this.captcha.verify();
                    //行为验证bug:点击关闭按钮，会点击穿透
                    //解决：手动再添加一个遮罩层
                    this.captchaMask = true;
                }
            }
        },
        //
        async loginSet() {
            var _this = this;
            var key = "member_login_tip";
            let res = await this.$http.get(this.$api.getRegisterSet, key);
            if (res.code == 0) {
                _this.loginJson = res.data.svalue;
            }
        },
        captchaData: async function(type) {
            let _this = this;
            const res = await this.$http.get(_this.$api.captcha);
            if (res.code == 0) {
                _this.verifyCodeImg = res.data.captcha_image_content;
                _this.captchaKey = res.data.captchaKey;
            } else {
            }
        },
        login: async function() {
            let captcha1 = document.querySelector("#captcha1");
            //登录接口
            var aseKey = "pigxpigxpigxpigx"; //秘钥
            // Encrypt 加密
            let encodePassword = MyAes.encrypt(this.password, aseKey);
            // Decrypt 解密
            // let decodePassword = MyAes.decrypt(encodePassword, aseKey);
            let _this = this;
            if (!this.accountNumber) {
                this.$message.error(_this.$t("loginPage.accountE"));
                return;
            } else if (!this.password) {
                this.$message.error(_this.$t("loginPage.passwordE"));
                return;
            } else if (this.type == 0 && !this.captchaCode) {
                this.$message.error(_this.$t("loginPage.verifyCodeE"));
                return;
            }

            if (this.type != 0) {
                var result = this.captcha.getValidate();

                if (!result) {
                    this.$message.error(_this.$t("loginPage.firstVerify"));
                    return;
                }
            }

            if (this.validateStatus === -1) {
                //登录异常验证
                this.validateLogin(encodePassword);
                return;
            }

            if (!this.isClickLogin) {
                return;
            }

            this.isClickLogin = false;

            let params = {
                name: this.accountNumber,
                password: encodePassword,
                lastLoginVersion: this.$config.loginVersion,
                validateType: this.type
            };

            //账号处理
            if (window.mergeAccount) {
                params.name = this.accountNumber + window.mergeAccount;
            }

            if (this.type === 1) {
                params.geeTestQueryVO = {
                    challenge: result.geetest_challenge,
                    seccode: result.geetest_seccode,
                    validate: result.geetest_validate
                };
            } else if (this.type === 2) {
                params.shuMeiQueryVO = {
                    rid: result.rid
                };
            } else if (this.type === 0) {
                params.captchaKey = this.captchaKey;
                params.captchaCode = this.captchaCode;
            } else if(this.type === 3){
                params.geeTestQueryVO = result
            }
            const res = await _this.$http.post(_this.$api.login, params, true);
            if (res.code == 0) {
                if (res.data.firstLogin) {
                    _this.show = false;
                    _this.dataList = res.data;
                } else {
                    //登录成功提示
                    this.$message({
                        message: _this.$t("loginPage.loginSuccess"),
                        type: "success"
                    });
                    //第一次登录
                    sessionStorage.setItem("firstLogin", true);
                    store.commit("firstLogin", true);

                    _this.$common.setUser(res.data);
                    _this.$common.setToken(res.data);

                    //获取个人信息
                    this.$nkhttp.getUserInfo();
                    this.hideDialog();
                    store.commit("advertisingShow", 1);
                }
                
                if (this.$route.path == "/index") {
                    setTimeout(() => {
                        this.$router.push('/')
                    },0)
                }
                
            } else {
                this.$common.clearToken();
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
                if (_this.type === 1) {
                    captcha1.innerHTML = "";
                }
                this.getDefaultStatus();
                this.isClickLogin = true;
            }
        },
        switchVisible() {
            this.defaultType = !this.defaultType;
        },
        hideDialog() {
            //隐藏
            this.show = false;
        },
        notHideDialog() {},
        toCDB(str) {
            //全角转为半角
            var tmp = "";
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) == 12288) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
                }
                if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
                } else {
                    tmp += String.fromCharCode(str.charCodeAt(i));
                }
            }
            return tmp;
        },
        accountBlur() {
            //   //大写转小写
            this.accountNumber = this.accountNumber.toLowerCase();
            //   //全角转半角
            //   this.accountNumber = this.toCDB(this.accountNumber);
            //   //空格处理
            // eslint-disable-next-line no-useless-escape
            this.accountNumber = this.accountNumber.replace(/\ /g, "");
        },
        passwordBlur() {
            //   //大写转小写
            //   this.password = this.password.toLowerCase();
            //   //全角转半角
            //   this.password = this.toCDB(this.password);
            //   //空格处理
            // eslint-disable-next-line no-useless-escape
            // this.password = this.password.replace(/\ /g, "");
        },
        // toCustomerService() {
        //     const url = this.$common.getCustomerService();
        //     window.open(url, "_blank");
        // },
        showForgetPsw() {
            var _this = this;
            _this.show = false;
            setTimeout(() => {
                _this.$refs.forgetPsw.openDialog();
            }, 1000);
        },
        toRegister() {
            this.show = false;
            this.$router.push("/register");
        },
        async validateLogin(encodePassword) {
            let captcha1 = document.querySelector("#captcha1");
            var _this = this;
            var params = {
                name: _this.accountNumber,
                password: encodePassword
            };

            //账号处理
            if (window.mergeAccount) {
                params.name = this.accountNumber + window.mergeAccount;
            }
            const res = await _this.$http.post(
                _this.$api.validateLogin,
                params,
                true
            );
            if (res.code == 0) {
                _this.validateStatus = res.data.validateStatus ? 1 : 0;
                if (_this.validateStatus === 1) {
                    //无异常
                    _this.login();
                } else {
                    this.$refs.validateLogin.openDialog();
                }
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
                if (_this.type === 1) {
                    captcha1.innerHTML = "";
                }
                this.getDefaultStatus();
            }
        }
    },
    watch: {
        show(n) {
            if (n) {
                //初始化数据
                this.captchaCode = "";
                this.captchaKey = "";
                this.accountNumber = "";
                this.password = "";
                this.defaultType = false;
                this.validateStatus = -1;
            } else {
                let captcha1 = document.querySelector("#captcha1");
                captcha1 && captcha1.remove();
            }
        }
    },
    components: {
        forgetPsw,
        validateLogin
    }
};
</script>

<style lang="less">
.login-layout {
    //   el-dialog
    > .el-dialog__wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        .logDialog {
            margin: 0 !important;
            border-radius: 0.1rem;
            border: solid 2px #ffff7b;
            background-color: #272727;
            .el-dialog__header {
                padding: 0 !important;
            }
            .el-dialog__body {
                padding: 0.3rem 0.4rem 0.1rem;
                box-sizing: border-box;
                position: relative;
            }
        }
    }
    .close-img {
        position: absolute;
        top: -0.2rem;
        right: -0.15rem;
        width: 0.4rem;
        height: 0.4rem;
        transition: 1s;
    }
    .close-img:hover {
        transform: rotate(180deg);
    }
    .log-title {
        width: 100%;
        height: 0.46rem;
        text-align: center;
        border-bottom: 0.02rem solid #222;
        color: #fbe089;
        cursor: pointer;
        margin-bottom: 0.16rem;
        font-size: 0.22rem;
        position: relative;
    }

    .log-container {
        .log-row {
            display: flex;
            align-items: center;
            position: relative;
            height: 0.6rem;

            input {
                flex: 1;
                background-color: #171717;
                color: #fff;
            }
            .right-img {
                position: absolute;
                width: 0.4rem;
                height: 0.42rem;
                top: 50%;
                transform: translateY(-50%);
                right: 0.3rem;
                flex-shrink: 0;
                display: none;
            }
        }
        .account-row {
            input {
                border-radius: 0.06rem 0.06rem 0 0;
                border-bottom: 1px solid #e6e6e6;
                box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
            }
        }
        .password-row {
            input {
                border-radius: 0 0 0.06rem 0.06rem;
            }
        }
        .code-row {
            border: none;
            justify-content: space-between;
            .verifyCodeImg {
                width: 1.2rem;
                height: 0.44rem;
                border-radius: 0.1rem;
                background: #ededed;
                background-size: 100% 100%;
                margin-left: 0.1rem;
            }
        }
        .marginStyle {
            margin: 0.15rem 0 0.2rem;
        }

        .log-btn :hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
        }

        .log-bottom {
            display: flex;
            justify-content: space-between;
            font-size: 0.12rem;
            margin-top: 0.15rem;
            padding-bottom: 0.15rem;
        }
        .updateTips {
            text-align: left;
            line-height: 0.26rem;
            font-size: 0.14rem;
            margin-top: 0.16rem;
            .themeTextColor {
                color: #ff3a2b;
            }
        }
    }

    #captcha1 {
        flex: 1;
        height: 0.44rem;
        border-radius: 0.1rem;
        background-color: #f9f9f9;
    }
    .getCode {
        height: 0.44rem;
        border-radius: 0.1rem;
        background: #fff;
        border: 0.02rem solid #f0f0f0;
        width: 100%;
        color: #313131;
        .refimg {
            width: 0.22rem;
            vertical-align: middle;
        }
    }
}
</style>
